export default __webpack_public_path__ + "static/IBMPlexSans-Text-a0170a8354caa4d8158933f20e0fe9b9.woff";